import { Box, Grid, Typography, useTheme } from "@mui/material";
import React, { useCallback } from "react";
import { FixedSizeList as List } from "react-window";
import ProductListRow from "./ProductListRow";
import CTABlock from "../../../components/CTABlock/index.js";

const AreaCountList = ({
  stockCountRecords,
  isMobileMode,
  updateBaseRecordQuantity,
  searchText,
  searching,
  selectedSectionId,
  section,
}) => {
  const theme = useTheme();
  const expected = selectedSectionId
    ? stockCountRecords.filter(
        (x) => x.sections.find((s) => s.id === selectedSectionId) !== undefined
      )
    : stockCountRecords;
  
  // Create itemData object to pass to List
  const itemData = {
    records: expected,
    updateBaseRecordQuantity,
    isMobileMode,
    searchText,
    searching,
    selectedSectionId,
  };
  
  // Memoized row renderer to improve performance
  const Row = useCallback(
    ({ index, style, data }) => {
      const { records, updateBaseRecordQuantity, isMobileMode, searchText, searching, selectedSectionId } = data;
      return (
        <div style={style}>
          <ProductListRow
            updateBaseRecordQuantity={updateBaseRecordQuantity}
            record={records[index]}
            index={index}
            key={records[index].id}
            mobileDisplay={isMobileMode}
            searchText={searchText}
            searching={searching}
            selectedSectionId={selectedSectionId}
          />
        </div>
      );
    },
    []
  );
  return (
    <>
      <Grid item sx={{ marginTop: 6 }}>
        {section ? (
          <Typography
            variant="h4"
            sx={{
              color: (theme) => theme.palette.terrain["02"],
              marginLeft: 1,
            }}
          >
            {section.name} Products
          </Typography>
        ) : null}
      </Grid>
      <Grid
        item
        sx={{
          marginTop: 3,
          padding: 0,
          border: "1px solid",
          borderColor: (theme) => theme.palette.terrain[400],
          backgroundColor: (theme) => theme.palette.pure.white,
          borderBottom: "none",
          borderRadius: "8px",
          overflow: "hidden",
        }}
      >
        {expected.length > 0 ? (
          <Box
            sx={{
              "& > div": {
                scrollbarWidth: "thin",
                scrollbarColor: theme.palette.mode === 'dark' 
                  ? `${theme.palette.terrain[600]} transparent`
                  : `${theme.palette.terrain[400]} transparent`,
                "&::-webkit-scrollbar": {
                  width: "12px",
                  height: "12px",
                },
                "&::-webkit-scrollbar-track": {
                  background: "transparent",
                },
                "&::-webkit-scrollbar-thumb": {
                  backgroundColor: theme.palette.mode === 'dark'
                    ? theme.palette.terrain[600]
                    : theme.palette.terrain[400],
                  borderRadius: "6px",
                  border: "2px solid transparent",
                  backgroundClip: "content-box",
                },
                "&::-webkit-scrollbar-thumb:hover": {
                  backgroundColor: theme.palette.mode === 'dark'
                    ? theme.palette.terrain[700]
                    : theme.palette.terrain[500],
                },
              },
            }}
          >
            <List
              height={Math.min(600, expected.length * 64)}
              itemCount={expected.length}
              itemSize={64}
              itemData={itemData}
              width="100%"
              overscanCount={5}
              style={{
                borderRadius: "8px",
              }}
            >
              {Row}
            </List>
          </Box>
        ) : (
          <>
            {searching ? (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: 4,
                  minHeight: "200px",
                }}
              >
                <Typography variant="body1" sx={{ color: (theme) => theme.palette.text.secondary }}>
                  No Results
                </Typography>
              </Box>
            ) : (
              <CTABlock
                header={`No Products are listed in this ${
                  selectedSectionId ? "section" : "area"
                }`}
                subheader={`Either add products to the ${
                  selectedSectionId ? "section" : "area"
                } or explore the unexpected products`}
                hideButton
              />
            )}
          </>
        )}
      </Grid>
    </>
  );
};

export default AreaCountList;
